// extracted by mini-css-extract-plugin
export default {"refreshStyle":"UnitStatsTable_refreshStyle__ngrY7","spinRefresh":"UnitStatsTable_spinRefresh__5DRUK","refreshStyleLoading":"UnitStatsTable_refreshStyleLoading__KUdRV"};